import { FC, useCallback } from 'react';
import { RangeKeyDict } from 'react-date-range';
import { useField } from 'formik';

import DateRangePickerBase from 'components/DateRangePickerBase';

export type Range = {
  start: Date | null;
  end: Date | null;
};

type Props = {
  name: string;
};

const DateRangePicker: FC<Props> = ({ name }) => {
  const [{ value }, , { setValue }] = useField<Range>(name);

  const handleChange = useCallback(
    (item: RangeKeyDict) => {
      setValue({
        start: item.selection.startDate ?? null,
        end: item.selection.endDate ?? null,
      });
    },
    [setValue]
  );

  return (
    <DateRangePickerBase
      ranges={[
        {
          startDate: value.start ?? undefined,
          endDate: value.end ?? undefined,
          key: 'selection',
        },
      ]}
      onChange={handleChange}
    />
  );
};

export default DateRangePicker;
